import React from 'react';

interface ITextWithLineProps {
  text: string;
}

const TextWithLine = ({text}: ITextWithLineProps) => {
  return (
    <div className="relative w-full">
      <div aria-hidden="true" className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-gray-200 dark:border-darkText" />
      </div>
      <div className="relative flex justify-center text-sm/6 font-medium">
        <span className="bg-slate-50 dark:bg-darkBg dark:text-darkText px-6 text-gray-900 rounded-full">{text}</span>
      </div>
    </div>
  );
};

export default React.memo(TextWithLine);
